// removed by extract-text-webpack-plugin
module.exports = {"commentForm_submit":"commentForm_submit___3u-PD","commentForm_list":"commentForm_list___1tbJ-","commentForm":"commentForm___2OAcz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/Comments.module.scss
// module id = 2376
// module chunks = 0